import { Outlet } from "react-router-dom";
import { StripeMeshGradient } from "@/components/StripeMeshGradient";

// Static gradient as fallback while WebGL loads
const STATIC_GRADIENT = 'linear-gradient(135deg, #1a0a10 0%, #2a0a3a 50%, #0a0a0a 100%)';

export default function UserFlowLayout() {
  return (
    <div className="fixed inset-0" style={{ overscrollBehavior: 'none', background: STATIC_GRADIENT }}>
      {/* Stripe WebGL animated mesh gradient */}
      <StripeMeshGradient
        color1="#0a0408"
        color2="#6B2D4A"
        color3="#3A0E6E"
        color4="#0a0408"
      />

      {/* Page content rendered on top */}
      <div className="relative z-10 h-full overflow-y-auto">
        <Outlet />
      </div>
    </div>
  );
}
